const PracticeRouter = [
  {
    path: '/practices/:id',
    name: 'practices',
    component: () => import('../../views/Practice/Practices.vue'),
    meta: {
      title: 'route.title.exam', // 考試
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: true, // 麵包屑
      keepAlive: true, // 缓存
      needAuthority: true, // 權限
      isBack: false,
    },
  },
  {
    path: '/practices/exam/:id/:subjectId',
    name: 'exam',
    component: () => import('../../views/Practice/Exam.vue'),
    meta: {
      title: 'route.title.exam', // 考試
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: true, // 麵包屑
      keepAlive: false, // 缓存
      needAuthority: true, // 權限
      isBack: false,
      backIs: 'practicesCategory',
    },
  },
  {
    path: '/practices/examHistory/:id/:subjectId',
    name: 'examHistory',
    component: () => import('../../views/Practice/ExamHistory.vue'),
    meta: {
      title: 'route.title.examHistory', // 測試紀錄
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: true, // 麵包屑
      keepAlive: true, // 缓存
      needAuthority: true, // 權限
      isBack: false,
      backIs: 'practicesCategory',
    },
  },
  {
    path: '/practices/examReview/:id/:subjectId/:examId',
    name: 'examReview',
    component: () => import('../../views/Practice/ExamReview.vue'),
    meta: {
      title: 'route.title.examHistory', // 測試紀錄
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: true, // 麵包屑
      keepAlive: false, // 缓存
      needAuthority: true, // 權限
      isBack: false,
      backIs: 'examHistory',
    },
  },
];

export default PracticeRouter;
